import clsx from "clsx";
import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

export const DealerPackagesColumns: FunctionComponent = () => {
  const { t } = useTranslation();
  return (
    <section
      className={clsx(
        "grid grid-cols-24 gap-2 xl:gap-3 px-4 py-2 items-center",
        "text-xs text-ink-2 mx-[1px] opacity-80"
      )}
    >
      <div className="col-span-8">
        {t("packageEditor.packageName")}
        <br />
        ID
      </div>
      <div className="col-span-4 xl:col-span-5">
        {t("packageEditor.brandIcon")}
      </div>
      <div className="col-span-4 xl:col-span-5">
        {t("packageEditor.partNumber")}
      </div>
      <div className="col-span-2 text-right">{t("packageEditor.myPrice")}</div>
      <div className="col-span-6 xl:col-span-4 pl-2 xl:pl-8">
        {t("packageEditor.actionsDetails")}
      </div>
    </section>
  );
};
